export default {
  primary: "#4361ee",
  secondary: "#3f37c9",
  accent: "rgb(55, 62, 97)",
  danger: "#f72585",
  success: "rgb(123, 179, 50)",
  grey: "#adb5bd",
  gray: "#4d4e4e",
  white: "#fff",
  offWhite: "rgb(209, 205, 205)",
  black: "#000000",
  transparentDark: "rgba(0, 0, 0, 0.8)",
  transparent: "rgba(0, 0, 0, 0.3)",
};
